import { AddressModels } from '../../../../models/address.models';
import { AddressApiModels } from '../../../../models/api/address-api.models';

export class AddressProjector {
  public static projectAddressResponse(
    apiAddress: AddressApiModels.Address,
  ): AddressModels.Address | any {
    if (!apiAddress) {
      return undefined;
    }

    return {
      streetName: apiAddress.streetName,
      streetNumber: apiAddress.streetNumber,
      streetType: apiAddress.streetType,
      repetition: apiAddress.repetition,
      cityName: apiAddress.cityName,
      cityZipCode: apiAddress.cityZipCode,
      complement: apiAddress.complement,
    };
  }

  public static projectAddressRequest(
    address: AddressModels.Address,
  ): AddressApiModels.Address {
    return Object.assign({}, <AddressApiModels.Address>address);
  }
}
